import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IInitState {
  loading: boolean;
  data: any;
  error: string;
  successMsg: any;
  filtersData: any;
  createPageStateLangPrefList: any;
  mainPageStateLangPrefList: any;
  mainPageSearchPaylaod: any;
  languageChoiceList: any;
  updatePageStateLangPrefList: any;
  updateFilterData:any;
  configurationListData:any;
  configurationLocalListData:any;
}

const initialState = {
  loading: false,
  data: [],
  error: "",
  successMsg: {},
  filtersData: {},
  createPageStateLangPrefList: [],
  updatePageStateLangPrefList: [],
  mainPageStateLangPrefList: [],
  mainPageSearchPaylaod: {},
  languageChoiceList: [],
  updateFilterData:{},
  configurationListData:[],
  configurationLocalListData:[],
};

const languagePreferanceSlice = createSlice({
  name: "languagePreferanceSlice",
  initialState,
  reducers: {
    getStatelanguagePrefListRequest(
      state: IInitState,
      action: PayloadAction<any>
    ) {
      state.loading = true;
    },
    getStatelanguagePrefListSuccess(
      state: IInitState,
      action: PayloadAction<any[]>
    ) {
      state.loading = false;
      state.createPageStateLangPrefList = action.payload;
    },
    emptyCreatePageLangPrefListData(state: IInitState) {
      state.loading = false;
      state.createPageStateLangPrefList = [];
    },
    getMainPageStatelanguagePrefListRequest(
      state: IInitState,
      action: PayloadAction<any>
    ) {
      state.loading = true;
      state.mainPageSearchPaylaod = action.payload;
      state.updateFilterData = {}
    },
    getMainPageStatelanguagePrefListSuccess(
      state: IInitState,
      action: PayloadAction<any[]>
    ) {
      state.loading = false;
      state.mainPageStateLangPrefList = action.payload;
    },
    emptyMainPageLangPrefListData(state: IInitState) {
      state.loading = false;
      state.mainPageStateLangPrefList = [];
    },
    getUpdatePageStatelanguagePrefListRequest(
      state: IInitState,
      action: PayloadAction<any>
    ) {
      state.loading = true;
      state.updatePageStateLangPrefList = action.payload;
    },
    getUpdatePageStatelanguagePrefListSuccess(
      state: IInitState,
      action: PayloadAction<any[]>
    ) {
      state.loading = false;
      state.updatePageStateLangPrefList = action.payload;
    },
    emptyUpdatePageLangPrefListData(state: IInitState) {
      state.loading = false;
      state.updatePageStateLangPrefList = [];
    },
    languageChoiceListRequest(state: IInitState, action: PayloadAction<any>) {
      state.loading = true;
    },
    languageChoiceListSuccess(state: IInitState, action: PayloadAction<any[]>) {
      state.loading = false;
      state.languageChoiceList = action.payload;
    },
    emptyLanguageChoiceListData(state: IInitState) {
      state.loading = false;
      state.languageChoiceList = [];
    },
    setConfigurationLocalListdata(state: IInitState, action: PayloadAction<any[]>){
      state.configurationLocalListData = [];
    },
    setFilterAfterUpdate(state: IInitState,action: PayloadAction<any>) {
      state.updateFilterData = action.payload;
    },
    
  },
});

export const {
  getStatelanguagePrefListRequest,
  getStatelanguagePrefListSuccess,
  emptyCreatePageLangPrefListData,
  getMainPageStatelanguagePrefListRequest,
  getMainPageStatelanguagePrefListSuccess,
  emptyMainPageLangPrefListData,
  languageChoiceListRequest,
  languageChoiceListSuccess,
  emptyLanguageChoiceListData,
  getUpdatePageStatelanguagePrefListRequest,
  getUpdatePageStatelanguagePrefListSuccess,
  emptyUpdatePageLangPrefListData,
  setFilterAfterUpdate,setConfigurationLocalListdata
} = languagePreferanceSlice.actions;
export default languagePreferanceSlice.reducer;
